import { edgeTypeMatrix, NodeEdgeMapper } from '@iotv/datamodel';
import { AdjacentType } from '@iotv/iotv-v3-types';
import ApiGateway from '../aws/api-gateway/ApiGateway';
const debug = process.env.REACT_APP_DEBUG && false;
/**
 * @function userViaCustomersTypeRoleQuery Returns the graph of user to first level related customers and then the related objects of customerRelatedObjectTypeId. Does not iterate down Customer hierarchy so user must by related directly to customer
 * @param user
 * @param customerRelatedObjectTypeId
 * @param normalizedData
 * @returns
 */
const userViaCustomersTypeRoleQuery = async function (user, customerRelatedObjectTypeId) {
    const nodeEdgeMapper = new NodeEdgeMapper();
    const path = '/graphQuery';
    const request = {
        contextObjects: [user],
        path: [
            { objectTypeId: 'Customer', adjacencyType: AdjacentType.PARENT, edgeTypeId: edgeTypeMatrix.Customer.User.customer_has_users.edgeTypeId },
            { objectTypeId: customerRelatedObjectTypeId, adjacencyType: AdjacentType.CHILD, edgeTypeId: undefined },
        ],
    };
    const responseBody = (await ApiGateway.post(path, request));
    debug && console.log('userViaCustomersTypeRoleQuery Res', responseBody);
    if (responseBody.data) {
        const { nodes, edges } = responseBody.data.hierarchy;
        nodeEdgeMapper.loadItems([...nodes, ...edges]);
    }
    else {
        console.log(`Err in userViaCustomersTypeRoleQuery ${responseBody.err?.message}`);
    }
    return nodeEdgeMapper;
};
export { userViaCustomersTypeRoleQuery };
